import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getStaffersList = async ({ commit }) => {
  commit('setStafferIsLoading', true);
  let url = `/staffers/selectable`;

  await connection.get(url)
    .then(res => {
      const staffers = res.data.data;
      commit('setStaffersSelectable', staffers);
      commit('setStafferIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStafferIsLoading', false);
    });
}

export const getStaffersByCountry = async ({ commit }, countryId) => {
  commit('setStafferIsLoading', true);
  let url = `/staffers/selectable/${countryId}`;

  await connection.get(url)
    .then(res => {
      const staffers = res.data.data;
      commit('setStaffersSelectable', staffers);
      commit('setStafferIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStafferIsLoading', false);
    });
}

export const loadStaffers = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setStafferIsLoading', true);
    let url = `/staffers`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const staffers = res.data.data;
        commit('setStaffers', staffers);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setStaffersPaginated', res.data);
        commit('setStafferIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setStafferIsLoading', false);
      });
}

export const stafferById = async ({ commit }, id) => {
  commit('setStafferIsLoading', true);
  await connection.get(`/staffers/${id}`)
    .then(res => {
      commit('setStafferDetail', res.data.data);
      commit('setStafferIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStafferIsLoading', false);
    });
}

export const storeStaffer = async ({ commit }, staffer) => {
  commit('setStafferIsCreating', true);
  await connection.post(`/staffers/create`, staffer)
    .then(res => {
      commit('saveNewStaffers', res.data);
      commit('setStafferIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStafferIsCreating', false);
    });
}

export const updateStaffer = async ({ commit }, staffer ) => {
  commit('setStafferIsUpdating', true);
  await connection.put(`/staffers/${staffer.id}/update`, staffer)
    .then(res => {
      commit('saveUpdatedStaffer', res.data);
      commit('setStafferIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStafferIsUpdating', false);
    });
}

export const deleteStaffer = async ({ commit }, staffer) => {
  commit('setStafferIsDeleting', true);
  await connection.get(`/staffers/${staffer.id}/active`)
    .then(res => {
      commit('setDeleteStaffer', res.data.data);
      commit('setStafferIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStafferIsDeleting', false);
    });
}